// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { useRoles } from '../verRolesContext';
import { CircularProgress, Divider, List, ListItem, ListItemText, Typography } from '@mui/material';
import { useBody } from '../../Body/state/BodyContext';

export default function VerRolesUser({ user }) {
    const { getUserRoles } = useRoles();
    const [userRoles, setUserRoles] = useState([]);
    const [loading, setLoading] = useState(false);
    const { setMessage } = useBody();

    const fetchUsersRoles = async () => {
        setLoading(true);
        try {
            const response = await getUserRoles(user.id);
            setUserRoles(response);
        } catch (error) {
            console.error("Error obteniendo los roles del usuario:", error);
            setMessage("Error obteniendo los roles del usuario");
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchUsersRoles();
    }, [user]);

    return (
        <>
            <Typography variant="h6" gutterBottom>
                Roles del Usuario: {user.firstName} {user.lastName}
            </Typography>

            <Divider style={{ marginBlock: "20px" }} />

            {loading ? (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <CircularProgress color="secondary" />
                </div>
            ) : (
                <List>
                    {userRoles.length > 0 ? (
                        userRoles
                            .filter((role) => role.name !== "uma_protection")
                            .map((role) => (
                                <ListItem key={role.id}>
                                    <ListItemText
                                        primary={<strong>{role.name}</strong>}
                                        secondary={role.description}
                                    />
                                </ListItem>
                            ))
                    ) : (
                        <Typography variant="body2" color="textSecondary">
                            No tiene roles asignados.
                        </Typography>
                    )}
                </List>
            )}
        </>
    );
}
